export default {"src":"/_next/static/media/next-auth.5f3d84b8.svg","height":361,"width":327,"blurWidth":0,"blurHeight":0};